import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Fade } from "react-reveal";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import GalleryModal from "../../components/galleryModal/GalleryModal";
import ProjectsData from "../../shared/opensource/projects.json";
import { galleryData } from "../../shared/galleryData";
import { projectDetails } from "../../shared/projectDetails";
import "./ProjectDetail.css";

function hasRealUrl(url) {
  if (!url) return false;
  if (url === "https://github.com/Ghassen-Ben-Nasser") return false;
  return true;
}

function getLinkLabel(url) {
  if (url.includes("github.com")) return "GitHub ↗";
  if (url.includes("upwork.com")) return "Upwork ↗";
  return "Live Demo ↗";
}

function ProjectDetail({ theme }) {
  const { id } = useParams();
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const project = ProjectsData.data.find((p) => p.id === id);

  if (!project) {
    return (
      <div
        className="pd-main"
        style={{ backgroundColor: theme.body, color: theme.text }}
      >
        <div className="pd-container">
          <Link
            to="/projects"
            className="pd-back"
            style={{ color: theme.secondaryText }}
          >
            ← Projects
          </Link>
          <p style={{ marginTop: 40 }}>Project not found.</p>
        </div>
      </div>
    );
  }

  const gallery = galleryData[id] || [];
  const details = projectDetails[id] || {};
  const longDescription = details.longDescription || project.description;
  const year = project.createdAt.split("-")[0];
  const showLink = hasRealUrl(project.url);

  return (
    <div className="pd-main" style={{ backgroundColor: theme.body }}>
      <div className="pd-container">
        {/* Back nav */}
        <Fade bottom duration={400} distance="10px">
          <Link
            to="/projects"
            className="pd-back"
            style={{ color: theme.secondaryText }}
          >
            ← Projects
          </Link>
        </Fade>

        {/* Header */}
        <Fade bottom duration={600} distance="20px">
          <div className="pd-header">
            <p className="pd-year" style={{ color: theme.secondaryText }}>
              {year}
            </p>
            <h1 className="pd-title" style={{ color: theme.text }}>
              {project.name}
            </h1>

            <div className="pd-tags">
              {project.languages.map((lang) => (
                <span
                  key={lang.name}
                  className="pd-tag"
                  style={{
                    color: theme.text,
                    borderColor: theme.text + "30",
                    backgroundColor: theme.text + "08",
                  }}
                >
                  {lang.name}
                </span>
              ))}
            </div>
          </div>
        </Fade>

        <div
          className="pd-divider"
          style={{ backgroundColor: theme.text + "15" }}
        />

        {/* Description + link */}
        <Fade bottom duration={600} distance="20px">
          <div className={`pd-body${showLink ? "" : " pd-body--no-link"}`}>
            <p className="pd-desc" style={{ color: theme.secondaryText }}>
              {longDescription}
            </p>
            {showLink && (
              <div className="pd-links">
                <a
                  href={project.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="pd-link-btn"
                  style={{
                    color: theme.text,
                    borderColor: theme.text + "40",
                  }}
                >
                  {getLinkLabel(project.url)}
                </a>
              </div>
            )}
          </div>
        </Fade>

        {/* Gallery */}
        {gallery.length > 0 && (
          <>
            <div
              className="pd-divider"
              style={{ backgroundColor: theme.text + "15" }}
            />
            <Fade bottom duration={600} distance="20px">
              <div className="pd-gallery-header">
                <p
                  className="pd-gallery-label"
                  style={{ color: theme.secondaryText }}
                >
                  Screenshots
                </p>
                <span
                  className="pd-gallery-count"
                  style={{ color: theme.secondaryText }}
                >
                  {gallery.length}
                </span>
              </div>
            </Fade>

            <div className="pd-gallery-grid">
              {gallery.map((item, i) => (
                <Fade
                  key={i}
                  bottom
                  duration={500}
                  distance="12px"
                  delay={i * 35}
                >
                  <div
                    className="pd-gallery-item"
                    onClick={() => setLightboxIndex(i)}
                    style={{ borderColor: theme.text + "10" }}
                  >
                    {item.type === "video" ? (
                      <div
                        className="pd-gallery-video"
                        style={{ backgroundColor: theme.text + "08" }}
                      >
                        <span className="pd-gallery-play">▶</span>
                      </div>
                    ) : (
                      <img src={item.src} alt={`Screenshot ${i + 1}`} />
                    )}
                    <div className="pd-gallery-zoom">
                      <span>⊕</span>
                    </div>
                  </div>
                </Fade>
              ))}
            </div>
          </>
        )}
      </div>

      {lightboxIndex !== null && (
        <GalleryModal
          items={gallery}
          startIndex={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
        />
      )}

      <Footer theme={theme} />
      <TopButton theme={theme} />
    </div>
  );
}

export default ProjectDetail;
